import DOMPurify from 'dompurify'

const isObject = (obj) => {
  return typeof obj === 'object' && obj !== null && obj !== undefined ? true : false
}

const parseObject = (obj) => {
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const element = obj[key]
      if (isObject(element)) {
        obj[key] = parseObject(element)
      } else if (typeof element === 'string') {
        obj[key] = DOMPurify.sanitize(element)
      }
    }
  }
  return obj
}
export const sanitizeParam = (obj) => {
  if (isObject(obj)) {
    return parseObject(obj)
  } else {
    return obj
  }
}
